import { useEffect, useState } from "react";
import { List, ListItem, ListItemText } from "@mui/material";
import Divider from "@mui/material/Divider";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import {
  CategoryOutlined,
  Group,
  HomeOutlined,
  LeaderboardOutlined,
  LogoutOutlined,
  NewspaperOutlined,
  ThumbsUpDownOutlined,
} from "@mui/icons-material";
import { useGoogleAuthContext } from "../contexts/GoogleAuthContext";

export const Sidebar = ({ handleComponent }: any) => {
  useEffect(() => {
    handleComponent("propostas");
  }, []);

  const { auth } = useGoogleAuthContext();

  return (
    <>
      <List>
        <ListItem key={"dashboard"} disablePadding>
          <ListItemButton onClick={() => handleComponent("dashboard")}>
            <ListItemIcon>
              <LeaderboardOutlined />
            </ListItemIcon>
            <ListItemText primary={"Dashboard de métricas"} />
          </ListItemButton>
        </ListItem>
        <ListItem key={"eventos"} disablePadding>
          <ListItemButton onClick={() => handleComponent("eventos")}>
            <ListItemIcon>
              <NewspaperOutlined />
            </ListItemIcon>
            <ListItemText primary={"Gerenciar eventos"} />
          </ListItemButton>
        </ListItem>
        <ListItem key={"propostas"} disablePadding>
          <ListItemButton onClick={() => handleComponent("propostas")}>
            <ListItemIcon>
              <ThumbsUpDownOutlined />
            </ListItemIcon>
            <ListItemText primary={"Avaliar propostas"} />
          </ListItemButton>
        </ListItem>
        <ListItem key={"temas"} disablePadding>
          <ListItemButton onClick={() => handleComponent("temas")}>
            <ListItemIcon>
              <CategoryOutlined />
            </ListItemIcon>
            <ListItemText primary={"Gerenciar temas"} />
          </ListItemButton>
        </ListItem>
        <ListItem key={"grupos"} disablePadding>
          <ListItemButton onClick={() => handleComponent("grupos")}>
            <ListItemIcon>
              <Group />
            </ListItemIcon>
            <ListItemText primary={"Avaliar grupos"} />
          </ListItemButton>
        </ListItem>
      </List>
      <Divider />
      <List>
        <ListItem key={"Logout"} disablePadding>
          <ListItemButton onClick={() => auth.signOut()}>
            <ListItemIcon>
              <LogoutOutlined />
            </ListItemIcon>
            <ListItemText primary={"Logout"} />
          </ListItemButton>
        </ListItem>
      </List>
    </>
  );
};

export default Sidebar;
